/**
 * Created by piotr.pozniak@thebeaverhead.com on 13/10/2018.
 */

import React from "react";
import { useTranslation } from "react-i18next";
import classnames from "classnames";

/**
 *
 * @param props
 * @param {function} props.onChangeDate
 * @returns {React.JSX.Element}
 * @constructor
 */
const MonthSelector = (props) => {
  const { t } = useTranslation();

  /**
   *
   * @param direction
   * @returns {function(...[*]=)}
   */
  const onDateChange = (direction) => () => {
    props.onChangeDate(direction);
  };

  return (
    <div className="rev-navigation">
      <button
        type="button"
        className={classnames(
          "dce-btn-reset",
          "rev-navigation-arrow",
          "rev-navigation-arrow_prv"
        )}
        onClick={onDateChange(-1)}
        aria-label={t("Previous month")}
      >
        <i className="material-icons" aria-hidden="true">
          keyboard_arrow_left
        </i>
      </button>

      <button
        type="button"
        className={classnames(
          "dce-btn-reset",
          "rev-navigation-arrow",
          "rev-navigation-arrow_next"
        )}
        onClick={onDateChange(1)}
        aria-label={t("Next month")}
      >
        <i className="material-icons" aria-hidden="true">
          keyboard_arrow_right
        </i>
      </button>
    </div>
  );
};

export default MonthSelector;
